export const siteConfig = {
  name: "SellerSupply Shop",
  shortName: "SellerSupply",
  title: "SellerSupply Shop - Global Online Store",
  description: "Shop practical products with multilingual support, manual payment options, and a simple checkout experience.",
  url: "https://dianzishangwu.pages.dev",
  ogImage: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&w=1200&q=80"
};
